import { createContext, use } from 'react';

import { GuidedJourneyStep } from '@/components/guidedJourney/model/GuidedJourney.model.ts';

type GuidedJourneyContextValue = {
  advanceStep: (journeyId: string, version: number, stepId: string) => void;
  completeJourney: (journeyId: string, version: number) => void;
  requestStep: (step: GuidedJourneyStep) => () => void;
};

const GuidedJourneyContext = createContext<GuidedJourneyContextValue>({
  advanceStep: () => undefined,
  completeJourney: () => undefined,
  requestStep: () => () => undefined,
});

export const GuidedJourneyContextProvider = GuidedJourneyContext.Provider;

export const useGuidedJourney = (): GuidedJourneyContextValue => use(GuidedJourneyContext);
